import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export const PanelHeaderTemplate = (options, type, selectedData, setselected, handleEvents, key,params) => {

    const handleApiCall = () => {
        if (handleEvents) {
            if (key !== undefined) {
                handleEvents('reset', key, type,params)
            }
            else {
                handleEvents(key, type,options,params)
            }
        }
    }

    return (
        <div className={options.className}>
            <span>{options.checkboxElement}</span>
            <span>{options.filterElement}</span>
            <span
                className={options.closeElementClassName}
                onClick={(e) => { options?.props.resetFilter(); options.onCloseClick(e); setselected([]); handleApiCall(); }}  >
                <FontAwesomeIcon icon="fa-solid fa-close" className={options.closeIconClassName} />
            </span>
        </div>
    );
};



export default PanelHeaderTemplate;